module.exports = require("@swissquote/crafty-commons/packages/once.js");